// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quantity-selector {
  display: flex;
  font-size: calc(var(--quantity-selector-height) / 2);
}
.quantity-selector > * {
  border-top: var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;
  border-bottom: var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;
  background: var(--quantity-selector-background);
  line-height: var(--quantity-selector-height);
  padding: 0;
  text-align: center;
  font-weight: bold;
}
.quantity-selector > *:first-child {
  border-left: var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;
  border-top-left-radius: 28px;
  border-bottom-left-radius: 28px;
}
.quantity-selector > *:last-child {
  border-right: var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;
  border-top-right-radius: 28px;
  border-bottom-right-radius: 28px;
}

.square {
  width: var(--quantity-selector-height);
  height: var(--quantity-selector-height);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.rectangle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(1 * var(--quantity-selector-height));
  height: var(--quantity-selector-height);
}`, "",{"version":3,"sources":["webpack://./src/app/components/quantity-selector/quantity-selector.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,oDAAA;AACF;AAAE;EACE,6FAAA;EACA,gGAAA;EACA,+CAAA;EACA,4CAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;AAEJ;AAAI;EACE,8FAAA;EACA,4BAAA;EACA,+BAAA;AAEN;AACI;EACE,+FAAA;EACA,6BAAA;EACA,gCAAA;AACN;;AAIA;EACE,sCAAA;EACA,uCAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gDAAA;EACA,uCAAA;AADF","sourcesContent":[".quantity-selector {\n  display: flex;\n  font-size: calc(var(--quantity-selector-height) / 2);\n  > * {\n    border-top: var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;\n    border-bottom:  var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;\n    background: var(--quantity-selector-background);\n    line-height: var(--quantity-selector-height);\n    padding: 0;\n    text-align: center;\n    font-weight: bold;\n\n    &:first-child {\n      border-left: var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;\n      border-top-left-radius: 28px;\n      border-bottom-left-radius: 28px;\n    }\n\n    &:last-child {\n      border-right: var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;\n      border-top-right-radius: 28px;\n      border-bottom-right-radius: 28px;\n    }\n  }\n}\n\n.square {\n  width: var(--quantity-selector-height);\n  height: var(--quantity-selector-height);\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.rectangle {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: calc(1 * var(--quantity-selector-height));\n  height: var(--quantity-selector-height);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
